export interface GetLookupRequest {
  startIndex?: number;
  endIndex?: number;
  searchParam?: string;
  planId?:string;
  id?: string;
  jobId?: string;
}
